export default __webpack_public_path__ + "static/media/wiom-logo-pink-bg.21be8330.svg";